import { CustomWindow } from '@utils/models/customwindow';
import { General } from '@utils/general';
import { useVideoBlockYouTube } from '@features/Components/VideoBlock/Scripts/video-block-youtube';
import { useVideoBlockMp4 } from '@features/Components/VideoBlock/Scripts/video-block-mp4';

declare let window: CustomWindow;

export const useBlockMedia = () => {
  const initialize = () => {
    setVideoHeight();

    window.addEventListener("resize", () => setVideoHeight(true));

    if (document.querySelector(".video-block__content--youtube")) {
      useVideoBlockYouTube();
      }

      if (document.querySelector(".video-block__content--mp4")) {
          useVideoBlockMp4();
      }

    window.KnowitOptimizelyFramework.BlockMediaScriptIsInitialized = true;
  };

  const initializeConsentCheck = (elements: NodeListOf<HTMLElement>) => {
    // If marketing cookies are blocked by CookieBot
    if (!window.Cookiebot?.consent?.marketing) {
      // Initialize YouTube
      elements.forEach(element => {
        const blockElement = element as HTMLElement;

        // If this script is already initialized
        if (blockElement.dataset.initializedConsent === "true") {
          return;
        }

        blockElement.classList.add("video-block__content--prevent-video");

        blockElement.addEventListener("click", () => {
          if (!window.Cookiebot?.consent?.marketing) {
            blockElement.classList.add("video-block__content--show-video");
          }
        });

        blockElement.addEventListener("keypress", (e: KeyboardEvent) => {
          if (!window.Cookiebot?.consent?.marketing) {
            if (e.key === 'Enter') {
              blockElement.classList.add("video-block__content--show-video");
            }
          }
        });

        // Set initialized attribute to prevent this script from running again
        blockElement.dataset.initializedConsent = "true";
      });
    }
  };

    const setVideoHeight = (isResize: boolean | null = false) => {
    document.querySelectorAll(".video-block__content").forEach(element => {
      const block = element as HTMLElement;
      const blockMediaIcon = block.querySelector(".video-block__icon") as HTMLDivElement;

      if ((block.dataset.initializedSetHeight === "true" && !isResize) || !blockMediaIcon) {
        return;
      }

      blockMediaIcon.style.opacity = "0";

      const image = block.querySelector("img") as HTMLImageElement;

      if (!image) {
        return;
      }

      General.loadImage(image).then((loadedImage: HTMLImageElement) => {
        // Use timeout to let the layout transition finish first
        setTimeout(() => {
          if (block instanceof HTMLElement) {
            const imgHeight = loadedImage.offsetHeight;

            // Set video height, this will position the icon in the middle
            const blockVideo = block.querySelector(".video-block__video");
            if (blockVideo instanceof HTMLElement && !!imgHeight) {
              blockVideo.style.height = `${imgHeight}px`;

              // Show icon after video height is set
              if (!!blockMediaIcon && !!imgHeight) {
                blockMediaIcon.style.opacity = "1";
              }
            }
          }
        }, 100);
      }).catch((error) => {
        console.error("Error loading image", error);
      });

      block.dataset.initializedSetHeight = "true";
    });
  };

  return {
    initialize,
    initializeConsentCheck,
  };
};

// Stage 1: Cookiebot is loaded
window.CookiebotCallback_OnLoad = () => {
  if (!window.KnowitOptimizelyFramework.BlockMediaScriptIsInitialized) {
    useBlockMedia().initialize();
  }
};

// Initialize and add ready class to video blocks when DOM is loaded
if (!window.KnowitOptimizelyFramework.BlockMediaScriptIsInitialized) {
  useBlockMedia().initialize();
}

document.querySelectorAll(".video-block__content").forEach(videoBlockContentElement => {
  videoBlockContentElement.classList.add("video-block__content--ready");
});